<template>
   <section class="flex h-full grow items-center bg-brand-dark text-center text-white">
      <div class="container flex max-w-xl flex-col items-center justify-center">
         <h2 class="text-xl lg:text-3xl">
            {{ $t("survey.resume.heading") }}
         </h2>
         <div class="mt-6 flex justify-center">
            <!-- resume Flow -->
            <DefaultButton data-cy="resume-flow" size="lg" :color="Theme.White" @click="$emit('go-to-last-block')">
               {{ $t("survey.resume.button_confirm") }}
            </DefaultButton>
            <!-- re-start Flow -->
            <DefaultButton
               data-cy="restart-flow"
               class="ml-4"
               size="lg"
               :color="Theme.White"
               @click="$emit('go-to-first-block')"
            >
               {{ $t("survey.resume.button_cancel") }}
            </DefaultButton>
         </div>
      </div>
   </section>
</template>

<script setup lang="ts">
import { Theme } from "@/types";

// Emits
// ------------------------------
const $emit = defineEmits(["go-to-last-block", "go-to-first-block"]);
</script>
